import React from "react";
import { AlertLineReportDTO } from "../../../../../models/alert-line-report/alert-line-report-dto";
import AlertLineReportNotes from "../../../../../containers/AlertLineReportNotes/AlertLineReportNotes";

interface Props {
  alertLineReport: AlertLineReportDTO;
}

const PreviousAlerLineReportNotes = ({ alertLineReport }: Props) => {
  return (
    <>
      <AlertLineReportNotes alertLineReport={alertLineReport} />
    </>
  );
};
export default PreviousAlerLineReportNotes;
